import React from 'react';

import { Link } from 'react-router-dom';

import { createTooltip } from '../../Impounds/hooks/useInvoices';

export default function reconstructRowDescription(descriptionData) {
  return (
    <div className="flex flex-col">
      {descriptionData.map((dt) => {
        return (
          <Link
            className="text-blue-600 underline flex items-center gap-1"
            to={dt?.link}
          >
            {dt?.description}
            {createTooltip({
              isPaidOutside: dt?.isPaidOutside,
              status: dt?.status,
            })}
          </Link>
        );
      })}
    </div>
  );
}
